import React from 'react';

export const PhoneDelete = (props) => (
  <svg
    fill="none"
    height="30"
    viewBox="0 0 46 30"
    width="46"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.7544 29.9776H42.6498C44.4962 29.9776 46 28.4738 46 26.6274V3.46206C46 1.61563 44.4962 0.113281 42.6498 0.113281H12.7544C11.6754 0.113281 10.6573 0.637192 10.03 1.5151L0.953642 14.222C0.601065 14.7148 0.601065 15.3746 0.953642 15.8674L10.0286 28.5729C10.6559 29.4523 11.674 29.9776 12.7544 29.9776Z"
      fill="#F5F5F5"
    />
    <line
      stroke="#6E7175"
      strokeWidth="2"
      x1="20.2757"
      x2="31.7696"
      y1="9.26946"
      y2="20.7633"
    />
    <path
      d="M31.5703 9.46875L20.0764 20.9626"
      stroke="#6E7175"
      strokeWidth="2"
    />
  </svg>
);
